import { CSSProperties } from "react";

export const style: CSSProperties = {
  width: "100vw",
  height: "100vh",
  margin: 0,
  padding: 0,
  boxSizing: "border-box",
  backgroundColor: "#fff"
};
